import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetNumber: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7 4v16M4 7h6m1.5-3v16m-3 0h6M17 4v16m-3-13h6" />
      </svg>
    </div>
  );
};

export default WidgetNumber;
